import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BcpAsyncLoader } from '@bcp/js-widgets';
import { CoreModule } from './contexts/login/infrastructure/core/core.module';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { AuthManagerModule } from './core/auth-manager/auth-manager.module';
import { InsightModule } from './contexts/login/infrastructure/services/insight.module';
import { BiometricModule } from './contexts/biometric/application/biometric.module'; 
import { B2cModule } from './contexts/b2c/application/b2c.module';
import { B2cVerificationModule } from './contexts/b2c/application/b2c-verification.module';
import { bcpProvideSafeRequestInterceptor } from '@bcp/js-networking';

@NgModule({
  declarations: [
    AppComponent,  
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,
    HttpClientXsrfModule.disable(), // ✅ DESHABILITA XSRF NATIVO de Angular
    AuthManagerModule,
    InsightModule,
    BiometricModule,
    B2cModule,
    B2cVerificationModule
  ],
  providers: [
    bcpProvideSafeRequestInterceptor({ HTTP_INTERCEPTORS }), // ✅ INTERCEPTOR que aplica el parche
    {
      provide: BcpAsyncLoader,
      useFactory: () => new BcpAsyncLoader(),
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
